import React, { useEffect, useState } from "react";
import ReactStrapTable from "components/reactStrapTable";
import { cellRendererCheck } from "utils/columns";
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  CardHeader,
  Nav,
  NavItem,
  Button,
} from "reactstrap";
import ErrorBoundary from "components/ErrorBoundary";
import Top10DrugPMPMDrawer from "pages/ClientDashBoard/Components/GridData/GridReports/Top10DrugPMPMDrawer";
import Drawer from "components/Drawer";
const TopdrugPMPM = ({ topDrugByPmpm , dateRange, planId, groupId, startDate,endDate,rebatechecked,planCode,groupCode}) => {
  const [summaryData, setSummaryData] = useState([]);
  const [disabledViewButtom, setDisabledViewButtom] = useState(true);
     const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (Array.isArray(topDrugByPmpm) && topDrugByPmpm.length > 0) {
      setDisabledViewButtom(false);
    } else {
      setDisabledViewButtom(true);
    }
  }, [topDrugByPmpm]);

  const handleProceed = () => {
    setIsOpen(!isOpen);
  };
  const currencyFormat = (value) => {
    if (!value || isNaN(value)) return "-";
    if (value < 0)
      return (
        <span className="text-danger text-end">
          {"-$" +
            (value * -1).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
        </span>
      );
    else
      return (
        <span className="text-end">
          {"$" + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
        </span>
      );
  };
  const TopDrugPMPMColumns = [
    {
      dataField: "drugName",
      text: "Drug Name",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.drugName),
    },
    {
      dataField: "pmpm",
      text: "PMPM",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => currencyFormat(row.pmpm),
    },
  ];
   const onHandleIsOpen = (hasRefresh)=> {
      
        if (isBoolean(hasRefresh) && hasRefresh) {
            onClose(true);
        }
        setIsOpen(!isOpen)
      }

  return (
    <ErrorBoundary>
    <Card className="p-3 h-100">
      <CardHeader className="border-0 bg-white px-0 pt-0">
        <Row className="align-items-center">
          <Col>
            <CardTitle className="f-20 font-weight-500">
              Top 10 Drugs By PMPM
            </CardTitle>
          </Col>
        </Row>
      </CardHeader>

      <CardBody className="dashboard-chart-body">
        <div
          className={`table-card scroll-table position-relative border-0 rounded pt-0 scroll ${
            Array.isArray(topDrugByPmpm) && topDrugByPmpm.length > 0
              ? "fixed-height"
              : ""
          }`}
        >
          <ReactStrapTable columns={TopDrugPMPMColumns} data={topDrugByPmpm} />
        </div>
        <div className="view-report">
          <Button
            color="primary"
            className="ms-2"
            onClick={handleProceed}
            style={{ float: "right", marginTop: "26px" }}
            disabled={disabledViewButtom}
          >
            View Report
          </Button>
        </div>
      </CardBody>
    </Card>
      <Drawer
                    direction='end'
                    title='Top 10 Drugs By PMPM'
                    isOpen={isOpen}
                    toggle={handleProceed}
                    size="lg"
                       disabled={disabledViewButtom}
                            
                >
    <Top10DrugPMPMDrawer  dateRange={dateRange} planId={planId} groupId={groupId} startDate={startDate} endDate={endDate} planCode={planCode} groupCode={groupCode} rebatechecked={rebatechecked} onHandleIsOpen={onHandleIsOpen}  />
                </Drawer> 

    </ErrorBoundary>
  );
};

export default TopdrugPMPM;
